import _createForOfIteratorHelper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/commandcollection
 */
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Collection of commands. Its instance is available in {@link module:core/editor/editor~Editor#commands `editor.commands`}.
 */

var CommandCollection = /*#__PURE__*/function () {
  /**
   * Creates collection instance.
   */
  function CommandCollection() {
    _classCallCheck(this, CommandCollection);

    /**
     * Command map.
     *
     * @private
     * @member {Map}
     */
    this._commands = new Map();
  }
  /**
   * Registers a new command.
   *
   * @param {String} commandName The name of the command.
   * @param {module:core/command~Command} command
   */


  _createClass(CommandCollection, [{
    key: "add",
    value: function add(commandName, command) {
      this._commands.set(commandName, command);
    }
    /**
     * Retrieves a command from the collection.
     *
     * @param {String} commandName The name of the command.
     * @returns {module:core/command~Command}
     */

  }, {
    key: "get",
    value: function get(commandName) {
      return this._commands.get(commandName);
    }
    /**
     * Executes a command.
     *
     * @param {String} commandName The name of the command.
     * @param {*} [...commandParams] Command parameters.
     * @returns {*} The value returned by the {@link module:core/command~Command#execute `command.execute()`}.
     */

  }, {
    key: "execute",
    value: function execute(commandName) {
      var command = this.get(commandName);

      if (!command) {
        /**
         * Command does not exist.
         *
         * @error commandcollection-command-not-found
         * @param {String} commandName Name of the command.
         */
        throw new CKEditorError('commandcollection-command-not-found: Command does not exist.', this, {
          commandName: commandName
        });
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return command.execute.apply(command, args);
    }
    /**
     * Returns iterator of command names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "names",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function names() {
      return _regeneratorRuntime.wrap(function names$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this._commands.keys(), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, names, this);
    })
    /**
     * Returns iterator of command instances.
     *
     * @returns {Iterable.<module:core/command~Command>}
     */

  }, {
    key: "commands",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function commands() {
      return _regeneratorRuntime.wrap(function commands$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.delegateYield(this._commands.values(), "t0", 1);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, commands, this);
    })
    /**
     * Iterable interface.
     *
     * Returns `[ commandName, commandInstance ]` pairs.
     *
     * @returns {Iterable.<Array>}
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._commands[Symbol.iterator]();
    }
    /**
     * Destroys all collection commands.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.commands()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var command = _step.value;
          command.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return CommandCollection;
}();

export { CommandCollection as default };